export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4610.a8d75769.jpg";